module.exports = __webpack_public_path__ + "img/knife_m9_bayonet.2609c267.svg";